import { useEffect, useState, useRef } from "react";
import agralogo from "../images/agra-logo.png";
import uplogo from "../images/UPPOLICE_LOGO.png";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FaUserCircle, FaChevronDown } from "react-icons/fa";
import UpgradeProfileModal from "../components/UpgradeProfileModal";
import backendUrl from "../Utils/backendUrl";
import "../css/Header.css";

export default function Header({ userData, setUserData }) {
  const [showMenu, setShowMenu] = useState(false);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);


  const navigate = useNavigate();

  const profileRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleLogout = () => {
    sessionStorage.clear();
    navigate("/");
  };

  const handleProfile = () => {
    navigate("/profile");
  };

  const fetchUserDetails = async () => {
    try {
      const token = sessionStorage.getItem("authToken");

      if (!token) return;

      const response = await axios.get(`${backendUrl}login`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data.success) {
        const freshUser = response.data.user;
        // Keep sessionStorage cache fresh for next refresh
        sessionStorage.setItem(
          "user",
          JSON.stringify({ isLoggedIn: true, userData: freshUser })
        );
        setUserData(freshUser);
      }
    } catch (err) {
      console.error("Error fetching user details:", err);
    }
  };

  useEffect(() => {
    fetchUserDetails();
  }, []);

  return (
    <div className="wrapper-navbar">
      <div className="container">
        <div className="row align-items-center">
          {/* Left Logo */}
          <div className="col-md-2 text-center d-none d-md-block">
            <img src={agralogo} style={{ width: "55px" }} alt="Agra Police" />
          </div>

          {/* Center Title */}
          <div className="col-md-8 text-center text-light">
            <h2 className="text-info fw-bold mb-0">COP Suvidha</h2>
            <small>Agra Police</small>
          </div>

          {/* Profile Dropdown */}

          <div
            className="col-md-2 d-flex justify-content-end position-relative"
            ref={profileRef}
          >
            <div
              className="profile-card"
              onClick={() => setShowMenu((prev) => !prev)}
            >
              <FaUserCircle className="profile-icon" />

              <div className="profile-info">
                <div className="profile-name">{userData?.name}</div>
                <div className="profile-username">{userData?.username}</div>
              </div>

              <FaChevronDown className="dropdown-arrow" />
            </div>

            {showMenu && (
              <div className="profile-dropdown-menu">
             {/* <button
                onClick={() => {
                  setShowUpgradeModal(true);
                }}
              >
                  Profile
                </button> */}

               {showUpgradeModal && (
                  <UpgradeProfileModal
                    isOpen={showUpgradeModal}
                    onClose={() => {setShowUpgradeModal(false)
                          setShowMenu(false);
                    }}
                    userid={userData?.userid}                     
                    userData={userData}
                    setUserData={setUserData}
                    backendUrl={backendUrl}
                  />
                )}

                <button className="logout-btn-dropdown" onClick={handleLogout}>
                  Logout
                </button>
              </div>
            )}
          </div>

          {/* Modal Outside Dropdown */}
       
        </div>
      </div>
    </div>
  );
}
